(function () {
  function initializeCategoryMenu(menu) {
    if (menu.dataset.irpInitialized === "true") return;
    menu.dataset.irpInitialized = "true";

    var categories = Array.from(menu.querySelectorAll("[data-irp-header-category-tab]"));
    var panels = Array.from(menu.querySelectorAll("[data-irp-header-category-panel]"));
    var closeTimer = null;

    function isDesktopHover() {
      return window.matchMedia("(hover: hover) and (min-width: 990px)").matches;
    }

    function cancelClose() {
      window.clearTimeout(closeTimer);
      closeTimer = null;
    }

    function activate(index) {
      categories.forEach(function (category) {
        category.classList.toggle("is-active", category.dataset.irpHeaderCategoryTab === index);
      });
      panels.forEach(function (panel) {
        panel.classList.toggle("is-active", panel.dataset.irpHeaderCategoryPanel === index);
      });
    }

    categories.forEach(function (category) {
      category.addEventListener("mouseenter", function () {
        activate(category.dataset.irpHeaderCategoryTab);
      });
      category.addEventListener("focus", function () {
        activate(category.dataset.irpHeaderCategoryTab);
      });
    });

    menu.addEventListener("mouseenter", function () {
      if (!isDesktopHover()) return;
      cancelClose();
      menu.open = true;
    });
    menu.addEventListener("mouseleave", function () {
      if (!isDesktopHover()) return;
      cancelClose();
      closeTimer = window.setTimeout(function () {
        menu.open = false;
      }, 280);
    });
    menu.addEventListener("keydown", function (event) {
      if (event.key !== "Escape") return;
      cancelClose();
      menu.open = false;
      menu.querySelector("summary").focus();
    });
  }

  function initializeMobileCategoryMenu(menu) {
    if (menu.dataset.irpMobileInitialized === "true") return;
    menu.dataset.irpMobileInitialized = "true";

    var groups = Array.from(menu.querySelectorAll("[data-irp-mobile-category-group]"));

    function setOpen(group, open) {
      var trigger = group.querySelector("[data-irp-mobile-category-trigger]");
      var panel = group.querySelector("[data-irp-mobile-category-panel]");
      if (!trigger || !panel) return;
      trigger.setAttribute("aria-expanded", open ? "true" : "false");
      panel.hidden = !open;
    }

    groups.forEach(function (group) {
      var trigger = group.querySelector("[data-irp-mobile-category-trigger]");
      if (!trigger) return;
      trigger.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        var shouldOpen = trigger.getAttribute("aria-expanded") !== "true";
        groups.forEach(function (otherGroup) { setOpen(otherGroup, otherGroup === group && shouldOpen); });
      });
    });
  }

  function initializeAll() {
    document.querySelectorAll("[data-irp-header-category-menu]").forEach(initializeCategoryMenu);
    var mobileGroups = document.querySelectorAll("[data-irp-mobile-category-group]");
    if (mobileGroups.length) initializeMobileCategoryMenu(mobileGroups[0].closest(".menu-drawer__menu"));
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initializeAll);
  else initializeAll();
  document.addEventListener("shopify:section:load", initializeAll);
})();
